module.exports = __webpack_public_path__ + "assets/img/returnBtn-8ea5cc89.png";